import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Container({ children, className = '' }) {
    return (_jsx("div", { style: {
            maxWidth: '80rem',
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: '1.5rem',
            ...(typeof window !== 'undefined' && window.innerWidth >= 768 ? { padding: '2rem' } : {})
        }, className: className, children: children }));
}
export function PageHeader({ title, subtitle }) {
    return (_jsxs("div", { style: { marginBottom: '2rem' }, children: [_jsx("h1", { style: {
                    fontSize: '1.875rem',
                    fontWeight: '900',
                    color: '#f5f5f5',
                    textTransform: 'uppercase',
                    letterSpacing: '-0.025em',
                    marginBottom: subtitle ? '0.5rem' : 0
                }, children: title }), subtitle && _jsx("p", { style: { color: '#999999', fontSize: '0.875rem' }, children: subtitle })] }));
}
